import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { TranslatorContext } from '@jutro/locale';
import { withRouter } from 'react-router-dom';
import { DropdownSelectField, InputNumberField } from '@jutro/legacy/components';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './EmployeesAndVolunteersComponent.module.scss';
import metadata from './EmployeesAndVolunteersComponent.metadata.json5';

function EmployeesAndVolunteersComponent(props) {

    const {
        data: EmployeesandVolunteersVM,
        updateWizardData,
        submissionVM,
        EmployeesandVolunteersPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);


    const addEmployeesandVolunteers = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            EmployeesandVolunteersVM.value = EmployeesandVolunteersVM.value || []

            const { _xCenter, _dtoName } = EmployeesandVolunteersVM;

            const EmployeesandVolunteersObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            EmployeesandVolunteersObjVM.value.numOfVol2 = 0
            EmployeesandVolunteersObjVM.value.numOfFulTimEmp3 = 0
            EmployeesandVolunteersObjVM.value.numOfParTimEmp4 = 0

            EmployeesandVolunteersVM.pushElement(
                EmployeesandVolunteersObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, EmployeesandVolunteersVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            EmployeesandVolunteersVM.value.splice(index, 1);
            _.set(submissionVM.value, EmployeesandVolunteersPath, EmployeesandVolunteersVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, EmployeesandVolunteersPath, EmployeesandVolunteersVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'claTyp1') {
                const value = (item && item.claTyp1) ? item.claTyp1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = EmployeesandVolunteersVM.length > 0 && EmployeesandVolunteersVM.children[index].claTyp1
                    // eslint-disable-next-line security/detect-object-injection
                    ? EmployeesandVolunteersVM.children[index].claTyp1.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.claTyp1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'numOfVol2') {
                const value = item.numOfVol2;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.numOfVol2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }

            if (path === 'numOfFulTimEmp3') {
                const value = item.numOfFulTimEmp3;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.numOfFulTimEmp3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }

            if (path === 'numOfParTimEmp4') {
                const value = item.numOfParTimEmp4;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.numOfParTimEmp4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }


        }, [handleValueChange, translator, EmployeesandVolunteersVM.value])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`EmployeesandVolunteersTable`]: {
            data: EmployeesandVolunteersVM.value,
        }

    }), [EmployeesandVolunteersVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addEmployeesandVolunteers,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            EmployeesandVolunteersVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [EmployeesandVolunteersVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={EmployeesandVolunteersVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

EmployeesAndVolunteersComponent.propTypes = wizardProps;
export default withRouter(EmployeesAndVolunteersComponent);
